import AlertsMenu from './AlertsMenu';

export default AlertsMenu;
